import React, { useMemo, useState } from "react";
import { DataGrid, GridColumns } from "@mui/x-data-grid";
import { Stack } from "@mui/material";

const MeasureLogsTable = ({ measureLogs }: { measureLogs: any[] }) => {
  const [historyPage, setHistoryPage] = useState(0);
  const [historyPageSize, setHistoryPageSize] = useState(6);

  const rows = useMemo(
    () =>
      (measureLogs || []).map((item: any, index: number) => ({
        id:
          item?.id ??
          `${item?.editedAt ?? ""}-${item?.userName ?? ""}-${index}`,
        ...item,
      })),
    [measureLogs],
  );

  const columns = React.useMemo<GridColumns<any>>(
    () => [
      {
        sortable: false,
        field: "editedAt",
        headerName: "Датум промене",
        maxWidth: 260,
        minWidth: 180,
        flex: 1,
        valueGetter: (params) =>
          params.row.editedAt
            ? new Date(params.row.editedAt).toLocaleString("sr-RS", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              })
            : "-",
      },
      {
        sortable: false,
        field: "userName",
        headerName: "Корисничко име",
        maxWidth: 220,
        minWidth: 180,
        flex: 1,
        valueGetter: (params) => params.row.userName || "-",
      },
      {
        sortable: false,
        field: "quarter",
        headerName: "Квартал",
        maxWidth: 140,
        minWidth: 100,
        flex: 1,
        valueGetter: (params) => params.row.quarter || "-",
      },
    ],
    [],
  );

  return (
    <div className="">
      <h2 className="text-[#404040] text-2xl font-bold mb-2">
        Историја измена мере
      </h2>
      <DataGrid
        rowCount={rows.length}
        pagination
        disableColumnMenu
        page={historyPage}
        pageSize={historyPageSize}
        onPageChange={(newPage) => setHistoryPage(newPage)}
        onPageSizeChange={(newPageSize) => setHistoryPageSize(newPageSize)}
        rows={rows}
        columns={columns}
        autoHeight={true}
        getRowHeight={() => "auto"}
        style={{ zIndex: 0 }}
        rowsPerPageOptions={[5, 10, 15]}
        disableSelectionOnClick
        components={{
          NoRowsOverlay: () => (
            <Stack height="100%" alignItems="center" justifyContent="center">
              Не постоји историја измена мере
            </Stack>
          ),
          NoResultsOverlay: () => (
            <Stack height="100%" alignItems="center" justifyContent="center">
              Не постоји историја измена мере
            </Stack>
          ),
        }}
      />
    </div>
  );
};

export default MeasureLogsTable;
